// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import "firebase/compat/firestore";
import "firebase/compat/storage";
// https://firebase.google.com/docs/web/setup#available-libraries

const firebaseConfig = {
    apiKey: "AIzaSyBqHM-5fpPx1bOq9eDUl_xSWPyAHqkiMEY",
    authDomain: "lontoone-5070b.firebaseapp.com",
    projectId: "lontoone-5070b",
    storageBucket: "lontoone-5070b.appspot.com",
    messagingSenderId: "256251757942",
    appId: "1:256251757942:web:fc6bc610f9e46716126657",
    measurementId: "G-ZKRDSZFEVE"
  };

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);


firebase.initializeApp(firebaseConfig);

const auth = firebase.auth();
const firestore = firebase.firestore();

export { firebase, auth, firestore };
